import { PropsWithChildren } from 'react'

interface Props {
  value: string | number
  checked: boolean
  onChange: (val: string | number) => void
  className?: string
}

export function Radio({ value, checked, onChange, children, className }: PropsWithChildren<Props>) {
  return (
    <label className={`cursor-pointer flex-x-center ${className}`}>
      <input
        type="radio"
        value={value}
        name="type"
        className="h-6 w-6 mr-10 cursor-pointer accent-primary"
        checked={checked}
        onChange={(event) => {
          onChange(event.target.value)
        }}
      />
      {children}
    </label>
  )
}
